// National job search (GROWTH-004): small helpers shared by the /jobs pages.
// Keep COMMUNITIES and the URL rules in sync with netlify/lib/national.js (CRA can't import it).
import { PROVINCES } from '../utils/provinces';

export const COMMUNITIES = [
  { slug: 'newcomers', label: 'Newcomers', site: 'NewJobLeads.ca' },
  { slug: 'youth', label: 'Youth', site: 'YouthJobLeads.ca' },
  { slug: 'disabilities', label: 'People with disabilities', site: 'AbleJobLeads.ca' },
  { slug: 'refugees', label: 'Refugees', site: 'RefugeeJobLeads.ca' },
  { slug: 'indigenous', label: 'Indigenous peoples', site: 'AboriginalJobLeads.ca' },
];
export const communityLabel = (slug) => (COMMUNITIES.find((c) => c.slug === slug) || {}).label || slug;

export const TURNSTILE_SITE_KEY = '0x4AAAAAAFDuRFN9K5A2WRt2'; // public site key (same widget as the boards)
export const APPLY_API = '/.netlify/functions/submitApplication';

export function slugify(value) {
  return String(value || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
    .replace(/-+$/g, '');
}

export const provinceName = (code) => (PROVINCES.find((p) => p.code === code) || {}).name || code;
export const provinceBySlug = (slug) => (PROVINCES.find((p) => slugify(p.name) === slug) || {}).code || '';
export const placePath = (province, city) => `/jobs/in/${slugify(provinceName(province))}${city ? `/${slugify(city)}` : ''}`;

// The data the edge function embedded for this exact URL (first load only), else null.
let embedded;
export function takeEmbedded(key) {
  if (embedded === undefined) {
    try {
      const el = document.getElementById('cjl-jobs-data');
      embedded = el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      embedded = null;
    }
  }
  if (embedded && embedded.key === key) {
    const { data } = embedded;
    embedded = null; // later navigations fetch fresh data
    return data;
  }
  return null;
}

export async function api(params) {
  const res = await fetch(`/api/jobs?${new URLSearchParams(params)}`);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || 'Jobs are unavailable right now. Please try again.');
    err.status = res.status;
    throw err;
  }
  return body.result;
}

// Exact dates, never relative (D-013).
export function prettyDate(iso) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00Z`);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

export function setTitle(title) {
  if (typeof document !== 'undefined') document.title = title;
}
